var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "reject-box"
  }, [_c("el-popover", {
    attrs: {
      "confirm-button-text": "好的",
      "cancel-button-text": "不用了",
      icon: "",
      placement: _vm.placement,
      "popper-class": "reject-modal"
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "slot-content",
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_vm._t("default")], 2), _c("div", {
    staticClass: "popover-content"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("拒绝通知")]), _c("div", {
    staticClass: "radio-list"
  }, [_c("el-radio-group", {
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.rejectType,
      callback: function callback($$v) {
        _vm.rejectType = $$v;
      },
      expression: "rejectType"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("发布房源")]), _c("el-radio", {
    attrs: {
      label: 3
    }
  }, [_vm._v("带联系方式")]), _c("el-radio", {
    attrs: {
      label: 4
    }
  }, [_vm._v("内容违规（赌博、仇恨言论、违规营销等）")]), _c("el-radio", {
    attrs: {
      label: 5
    }
  }, [_vm._v("违规禁售商品")]), _c("el-radio", {
    attrs: {
      label: 6
    }
  }, [_vm._v("宠物领养标价")])], 1)], 1), _c("div", {
    staticClass: "button-list"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: _vm.determine
    }
  }, [_vm._v("确定")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "warning"
    },
    on: {
      click: _vm.reject
    }
  }, [_vm._v("仅拒绝")]), _c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")])], 1)])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };